import React from 'react';
import ReactDOM from 'react-dom';
import Root from './Root';
import ReactGA from 'react-ga';
import './styles/main.scss';
import registerServiceWorker from './registerServiceWorker';

require('dotenv').config();

ReactGA.initialize(process.env.REACT_APP_GA_CODE);

ReactDOM.render(<Root />, document.getElementById('root'));
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js